import router from '@/router'
import { isUserLoggedIn } from '@/auth/utils'
import { jwtDecode } from 'jwt-decode'
import useJwt from '@/auth/jwt/useJwt'
import { ModuleEnum } from '@/enums/module'
const menu = [
  {
    title: 'Inicial',
    route: 'adm',
    icon: 'HomeIcon',
  },
  {
    title: 'Cadastro',
    icon: 'UserPlusIcon',
    children: [
      {
        title: 'Tomador',
        route: 'CadastroTomador',
      },
      {
        title: 'Órgão',
        route: 'CadastroOrgao',
      },
      {
        title: 'Grupo Folha',
        route: 'CadastroGrupoFolha',
      },
    ],
  },
  {
    title: 'Simulador de Proposta',
    route: 'Proposta',
    icon: 'ShoppingBagIcon',
  },
  {
    title: 'Contrato',
    route: 'Contrato',
    icon: 'FileTextIcon',
  },
  {
    title: 'Financeiro',
    icon: 'SlidersIcon',
    children: [
      {
        title: 'Pagamentos',
        route: 'FinanceiroPagamento',
      },
      {
        title: 'Remessa Boletos',
        route: 'FinanceiroRemessaBoleto',
      },
      {
        title: 'Lançamentos',
        route: 'FinanceiroLancamento',
      },
      {
        title: 'Arrecadação',
        route: 'FinanceiroArrecadacao',
      },
    ],
  },
  {
    title: 'Renegociação',
    icon: 'ShoppingBagIcon',
    children: [
      {
        title: 'Dívidas',
        route: 'RenegociacaoDividas',
      },
      {
        title: 'Antecipação',
        route: 'RenegociacaoAntecipacao',
      },
    ],
  },
  {
    title: 'Relatórios',
    icon: 'BarChartIcon',
    children: [
      {
        title: 'Cadastro',
        route: 'RelatorioCadastro',
      },
      {
        title: 'Simulador de Proposta',
        route: 'RelatorioSimulador',
      },
      {
        title: 'Contratos',
        route: 'RelatorioContrato',
      },
      {
        title: 'Financeiro',
        route: 'RelatorioFinanceiro',
      },
    ],
  },
  {
    title: 'Configurações',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Produto',
        route: 'Produto',
      },
      {
        title: 'Sistema',
        route: 'ConfiguracoesSistema',
      },
      {
        title: 'Cessionária',
        route: 'ConfiguracoesSistemaCessionariaAcessar',
      },
      {
        title: 'Unidade Gestora',
        route: 'CadastroUnidadeGestora',
      },
      {
        title: 'Assinatura Digital',
        route: 'AssinaturaDigital',
      },
    ],
  },
]
export async function getMenuWithPermissions() {
  const clonedMenu = JSON.parse(JSON.stringify(menu))
  const menuWithPerms = await verifyPermissions(clonedMenu)
  console.log(menuWithPerms)
  return menuWithPerms
}

export async function verifyPermissions(menuItems) {
  const isLoggedIn = isUserLoggedIn()

  const listaDePaginasSemProibicao = ['adm', 'AssinaturaDigital']
  const userDataStr = localStorage.getItem('userData')
  let grupoAcesso = null
  let role = null

  if (userDataStr) {
    const userDataParsed = jwtDecode(userDataStr)['userData']
    grupoAcesso = userDataParsed['GrupoAcesso']
    role = userDataParsed['role']
  }

  menuItems = menuItems.map((menuItem) => ({ ...menuItem, disabled: false, hidden: false }))

  if (!isLoggedIn) return menuItems

  if (role === 'master') {
    return await verifyModules(menuItems)
  }

  if (grupoAcesso) {
    menuItems = menuItems
      .map((menuItem) => {
        if (menuItem.children) {
          menuItem.children = menuItem.children.map((child) => {
            if (listaDePaginasSemProibicao.includes(child.route)) {
              return { ...child, disabled: false, hidden: false }
            }
            return { ...child, ...setVisibility(child, grupoAcesso[child.route]) }
          })

          const allChildrenDisabled = menuItem.children.every((child) => child.disabled && child.hidden)
          if (allChildrenDisabled) {
            return { ...menuItem, disabled: true, hidden: true }
          }

          menuItem.children = menuItem.children.filter((child) => !child.hidden)
        }

        if (listaDePaginasSemProibicao.includes(menuItem.route)) {
          return { ...menuItem, disabled: false, hidden: false }
        }

        if (menuItem.route) {
          return { ...menuItem, ...setVisibility(menuItem, grupoAcesso[menuItem.route]) }
        } else {
          return { ...menuItem, disabled: false, hidden: false }
        }
      })
      .filter((menuItem) => !menuItem.hidden)
  }
  const paramsModule = await verifyModules(menuItems)
  return paramsModule
}

function setVisibility(item, isAccessible) {
  return { disabled: !isAccessible, hidden: !isAccessible }
}

async function verifyModules(menuItems) {
  const response = await useJwt.get('sistema')
  const config = response.data.ConfiguracaoModulos

  const filteredMenu = menuItems.map((menuItem) => {
    const moduloKey = getEnumKeyByTitle(menuItem.title)
    const isModuloAtivo = moduloKey ? config[moduloKey] : true

    if (menuItem.children) {
      menuItem.children = menuItem.children.map((child) => {
        const subKey = getEnumKeyByTitle(child.title, moduloKey)
        const ativo = subKey ? config[subKey] : true
        return {
          ...child,
          disabled: !ativo,
          hidden: !ativo,
        }
      })

      const allChildrenHidden = menuItem.children.length === 0
      return {
        ...menuItem,
        disabled: !isModuloAtivo || allChildrenHidden,
        hidden: !isModuloAtivo || allChildrenHidden,
      }
    }

    return {
      ...menuItem,
      disabled: !isModuloAtivo,
      hidden: !isModuloAtivo,
    }
  })

  return filteredMenu
}

function getEnumKeyByTitle(title, moduloPrefix = '') {
  const entry = Object.entries(ModuleEnum).find(
    ([key, value]) =>
      value.toLowerCase() === title.toLowerCase() &&
      (moduloPrefix ? key.startsWith(moduloPrefix + '_') || key === moduloPrefix : true),
  )
  return entry ? entry[0] : null
}

export { menu }
